import { GridActions } from './../ActionTypes';

export const setPageNumber = (pageNumber) => ({
    type: GridActions.SetPageNumber,
    pageNumber
});

